"use client";
import OestraIcon from "@/icons/products/product-oestra-colored-label-with-r.svg";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import Reveal from "~/componentsDS/Reveal";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";

const PricingPlansSection = () => {
    return (
        <section className="font-suisseBP text-primary500 pb-16 md:pb-24 max-md:pt-16">
            <ElementorContainer rowGap="16px" columnGap="16px" innerClassName="flex flex-col">
                <Reveal>
                    <div className="mb-4">
                        <OestraIcon />
                    </div>

                    <Heading as="h2" size="sm" sizes={{ md: "md" }} className="text-primary500 text-[32px] font-light leading-[1.1] tracking-[-0.32px] md:text-[40px] md:tracking-[-1.2px]">
                        Hormone support, designed for the long-term
                    </Heading>
                </Reveal>

                <Paragraph className="max-w-[716px] text-[18px] font-normal leading-[1.3]">
                    Many women spend years adjusting,
                    <br className="md:hidden" /> switching, and layering. Oestra® replaces that
                    <br className="md:hidden" /> with one prescription routine — clinician-
                    <br className="md:hidden" /> guided, shipped to your door, at a price
                    <br className="md:hidden" /> designed to last.
                </Paragraph>

                <div className="text-pureWhite flex px-[18px] py-[25px] h-[608px] md:h-auto md:px-[124px] md:py-[51.5px] rounded-3xl flex-col bg-cover bg-[url(https://res.cloudinary.com/dirscuuhp/image/upload/v1779201620/new_design/Frame_2087327989_5_wpzy1d.webp)]
                md:bg-[url(https://res.cloudinary.com/dirscuuhp/image/upload/v1779192599/new_design/Frame_2087329121_fmwv4b.webp)]">
                    <div className="p-[14px] md:p-8 rounded-3xl bg-black/10 max-w-full md:max-w-[453px] mb-[10px]
                        shadow-[inset_0_-1px_2px_0_rgba(255,255,255,0.27),inset_0_8px_8px_-2px_rgba(255,255,255,0.03),inset_0_2px_4px_-1px_rgba(255,255,255,0.19)]">
                        <Reveal >
                            <Heading as="h4" className="font-featureDisplay max-[360px]:text-[22px] text-[28px] font-normal leading-[1.2] tracking-[0.28px]">
                            $199/mo = <span className="max-[360px]:text-[36px] text-[43px] font-normal leading-[1.2] tracking-[0.43px]">$7</span>/day
                            </Heading>
                            <Paragraph className="text-[18px] font-normal leading-[1.1]">for the first 6 months</Paragraph>
                        </Reveal>

                        <div className="h-[1px] w-full bg-pureWhite my-4 md:my-5"></div>

                        <Reveal>
                            <Paragraph className="text-[18px] font-normal leading-[1.1]">Then</Paragraph>
                            <Heading as="h4" className="font-featureDisplay max-[360px]:text-[22px] text-[28px] font-normal leading-[1.2] tracking-[0.28px]">
                            $99.50/mo = <span className="max-[360px]:text-[36px] text-[43px] font-normal leading-[1.2] tracking-[0.43px]">$3</span>/day
                            </Heading>
                        </Reveal>
                    </div>

                    <Paragraph className="text-center text-[18px] font-normal leading-[1.3] md:max-w-[453px]">
                        90-day supply shipped every 90 days, billed monthly.{" "}
                        <span className="md:block">Cancel anytime.</span>
                    </Paragraph>
                </div>
            </ElementorContainer>
        </section>
    );
}

export default PricingPlansSection